import React from "react";
import { Link } from "react-router-dom";

export const DataGhost = ({ title, subtitle, hasSubtitle }) => {
  return (
    <center>
      <div className="col" style={{ marginTop: "7rem", color: "#5E5E5E" }}>
        <i className="fas fa-exclamation-circle" style={{ fontSize: "32px" }}></i>
        <p style={{ margin: 0 }}>{title}</p>
        {hasSubtitle ? (
          <p>
            <Link to={{ pathname: "/planning/upload_file" }} >Click here </Link>
            {subtitle}
          </p>
        ) : null}
      </div>
    </center>
  );
};
